import { Nota } from './nota';

export class NotaSearch {
    id: number;
    idEmpresa: number;
    createdAt: Date;
    idUsuarioCreated: number;
    nomeUsuarioCreated: string;
    avatarUrlUsuarioCreated: string;
    updatedAt: Date;
    idUsuarioUpdated: number;
    nomeUsuarioUpdated: string;
    avatarUrlUsuarioUpdated: string;
    texto: string;
    idLead: number;
    idCliente: number;
    idNegocio: number;
    idTituloReceber: number;

    constructor(nota: Nota) {
        if (!nota) {
            return;
        }

        this.id = nota.id;
        this.idEmpresa = nota.idEmpresa;
        this.createdAt = nota.createdAt;
        this.idUsuarioCreated = nota.idUsuarioCreated;
        this.nomeUsuarioCreated = nota.usuarioCreated?.nome ?? null;
        this.avatarUrlUsuarioCreated = nota.usuarioCreated?.avatarUrl ?? null;
        this.updatedAt = nota.updatedAt;
        this.idUsuarioUpdated = nota.idUsuarioUpdated;
        this.nomeUsuarioUpdated = nota.usuarioUpdated?.nome ?? null;
        this.avatarUrlUsuarioUpdated = nota.usuarioUpdated?.avatarUrl ?? null;
        this.texto = nota.texto;
        this.idLead = nota.idLead;
        this.idCliente = nota.idCliente;
        this.idNegocio = nota.idNegocio;
        this.idTituloReceber = nota.idTituloReceber;
    }
}
